import React, { useState } from 'react';
import PropTypes from 'prop-types';
import postData from '../../utilities/postData';
import EditDeleteButton from '../shared/buttons/EditDeleteButton';
import CustomTd from '../shared/table/CustomTd';

const ApiTokenItem = ({
    canDelete,
    canEdit,
    deleteUrl,
    disabled,
    editItem,
    fetchData,
    item
}) => {
    function deleteItem(itemId) {
        postData(`${deleteUrl}/${itemId}`, null, fetchData);
    }

    const [showToken, setShowToken] = useState(false);

    return (
        <tr>
            <CustomTd>
                <div style={{ height: '1.9em', paddingTop: '.2em' }}>
                    {item.name}
                </div>
            </CustomTd>
            <CustomTd>
                <div style={{ height: '1.9em', paddingTop: '.2em' }}>
                    {item.franchiseName}
                </div>
            </CustomTd>
            <CustomTd>
                <div style={{ height: '1.9em', paddingTop: '.2em' }}>
                    {item.appUserName}
                </div>
            </CustomTd>
            <td>{showToken
                ? item.token
                : (<div className="cursor-pointer" onClick={() => setShowToken(true)}>--- Show Token ---</div>)
            }
            </td>
            <CustomTd width="98px">
                <div style={{ height: '1.9em', paddingTop: '.2em' }}>
                    <EditDeleteButton
                        showText={false}
                        canEdit={canEdit}
                        editItem={() => editItem(item.id)}
                        canDelete={canDelete}
                        deleteItem={() => deleteItem(item.id)}
                        acl={item.acl}
                        disabled={disabled}
                    />
                </div>
            </CustomTd>
        </tr>
    );
}

ApiTokenItem.defaultProps = {
    canDelete: true,
    canEdit: true
}

ApiTokenItem.propTypes = {
    fetchData: PropTypes.func,
    editItem: PropTypes.func,
    deleteUrl: PropTypes.string
};

export default ApiTokenItem;